export default __webpack_public_path__ + "static/media/intro-carib.95aa84f9.jpg";